import { faShareFromSquare } from '@fortawesome/free-regular-svg-icons';
import { errandButtonUtils } from '../../errandButtonUtils';
import { RetakeModal } from './RetakeModal';
export const RetakeButton = {
    key: 'retake',
    text: 'Återta',
    prio: 3,
    section: 'start',
    icon: faShareFromSquare,
    buttonStyle: 'success',
    ModalComponent: RetakeModal,
    onClick: async (row, inca, showModal, ctx, api)=>{
        const { isSuccess, result: { res, transitionShortname } } = await showModal();
        if (!isSuccess) {
            return;
        }
        const transitionResultModel = await errandButtonUtils.performStateTransition(transitionShortname, ctx, api, res);
        if (!transitionResultModel) {
            return;
        }
        inca.form.reload();
    },
    defaultRules: [
        {
            id: 'showWhenRetakePossible',
            description: 'Knappen blir enbart synlig om användaren är monitor och ärendet ligger i inrapportörs inkorg.',
            evaluateState: (row, inca, ctx)=>{
                if (inca.errand && inca.user.role.isReviewer && inca.errand && ctx.errand.isReadOnly && !!inca.errand.currentPosition.id) {
                    return {
                        state: 'Visible'
                    };
                }
                return {
                    state: 'Hidden'
                };
            }
        }
    ]
};
